import type { ComponentProps } from 'react';
import React from 'react';

import { useResponsive } from '../../hooks';
import { ScrollViewWithHeaderTitleSM } from './ScrollViewWithHeaderTitle.sm';
import { ScrollViewWithHeaderTitleXS } from './ScrollViewWithHeaderTitle.xs';

// ────────────────────────────────────────────────────────────────────────────────

export const ScrollViewWithHeaderTitle = React.forwardRef(
  (props: ScrollViewWithHeaderTitleProps, ref) => {
    const { minWidth } = useResponsive();

    if (minWidth.isSM) {
      return <ScrollViewWithHeaderTitleSM ref={ref} {...props} />;
    }

    return <ScrollViewWithHeaderTitleXS ref={ref} {...props} />;
  },
);

// ────────────────────────────────────────────────────────────────────────────────

type ScrollViewWithHeaderTitleProps = ComponentProps<
  typeof ScrollViewWithHeaderTitleXS
> &
  ComponentProps<typeof ScrollViewWithHeaderTitleSM>;
